import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import { FC } from 'react';

import { AppFeature } from '../dcbApp/types';

import { ListLink } from './ListLink';
import { drawerWidth } from './utils';

export interface AppDrawerProps {
  features: AppFeature[];
}

export const AppDrawer: FC<AppDrawerProps> = props => (
  <Drawer
    variant="permanent"
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
    }}
  >
    <Toolbar />
    <Box sx={{ overflow: 'auto', mt: 3 }}>
      <List>
        {props.features.map(listLink => (
          <ListLink
            key={`${listLink.path}`}
            linkProps={{ to: `${listLink.path}` }}
            icon={listLink.icon}
            label={listLink.label}
          />
        ))}
      </List>
    </Box>
  </Drawer>
);
